import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, CarIcon, SmartphoneIcon, ShieldCheckIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
export function ServiceConvenience() {
  const features = [{
    icon: <CalendarIcon className="w-8 h-8 text-brand-accent" data-id="element-144" />,
    text: 'Most diagnostic appointments available within 24 hours'
  }, {
    icon: <ClockIcon className="w-8 h-8 text-brand-accent" data-id="element-145" />,
    text: 'After-hours drop-off and pickup'
  }, {
    icon: <CarIcon className="w-8 h-8 text-brand-accent" data-id="element-146" />,
    text: 'Loaner vehicles available for qualifying repairs'
  }, {
    icon: <MapPinIcon className="w-8 h-8 text-brand-accent" data-id="element-147" />,
    text: 'Free rideshare when needed'
  }, {
    icon: <SmartphoneIcon className="w-8 h-8 text-brand-accent" data-id="element-148" />,
    text: 'Digital estimates sent to your phone before work begins'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8 text-brand-accent" data-id="element-149" />,
    text: '2-year / 24,000-mile warranty on qualifying repairs'
  }];
  return <section className="py-20 px-4 bg-brand-dark text-white" data-id="element-150">
      <div className="max-w-6xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-152">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-153">
            Auto service that fits your schedule
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold mb-6" data-id="element-154">
            Getting the real answer shouldn't be difficult.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-155">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-800/50 border border-gray-700 p-8 rounded-2xl flex flex-col items-center text-center hover:bg-gray-800 transition-colors" data-id="element-156">
              <div className="bg-gray-900 p-4 rounded-full mb-6 border border-gray-700" data-id="element-157">
                {feature.icon}
              </div>
              <p className="text-lg font-medium text-gray-200" data-id="element-158">
                {feature.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}